"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

var Card = {
  styles: function styles(theme) {
    return {
      root: {
        color: theme.colors.baseContrast085,
        padding: 0,
        "& > div:first-of-type": {
          padding: [theme.spacing.base * 1.5, theme.spacing.base * 2]
        }
      },
      titleContainer: {
        flexDirection: "row-reverse",
        justifyContent: "flex-end",
        padding: theme.spacing.base * 1.5,
        backgroundColor: theme.colors.baseContrast010,
        "&:hover": {
          backgroundColor: theme.colors.baseContrast015
        }
      },
      icon: {
        "& svg": {
          fill: theme.colors.baseContrast085
        }
      },
      contentContainer: {
        padding: [theme.spacing.base * 2, theme.spacing.base * 5]
      }
    };
  }
};
var _default = exports.default = Card;